import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/app/(alfamall)/wishlist/WishListModule/MobileWishListModule.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/AccountsPage/AccountsPage.jsx");
